import { Empty, Flex, Skeleton, Typography } from 'antd';
import styled from '@emotion/styled';
import { CopyOutlined, LikeOutlined } from '@ant-design/icons';

import LinkCard from 'pages/CustomerOverviewPage/LinkCard';
import QueryBoundary from 'components/QueryBoundary/QueryBoundary';

const TitleSkeleton = styled(Skeleton)`
  height: var(--heading-height-4);
  vertical-align: center;
  .ant-skeleton-section {
    vertical-align: middle;
    .ant-skeleton-title {
      margin: 0;
      display: block;
    }
  }
`;

const AccountOverview = ({
  accountTitle = 'Account',
  cardLast4,
  children,
  enableNavigation = false,
  navigateTo = '',
  onNavigate = () => {},
  query,
}) => {
  return (
    <LinkCard
      enabled={enableNavigation}
      onNavigate={onNavigate}
      to={navigateTo}
      title={
        <Flex
          justify="space-between"
          align="center"
          gap="var(--spacing)"
          style={{ height: '100%' }}
        >
          {query?.loading ? (
            <TitleSkeleton
              loading={true}
              active={true}
              paragraph={false}
            ></TitleSkeleton>
          ) : (
            <Typography.Title
              className="account-name"
              level={5}
              style={{ margin: 0 }}
              copyable={{
                text: `${cardLast4}`,
                tooltips: [
                  'Copy Card Last 4',
                  <span key="copied-message">
                    Card Last 4 Copied <LikeOutlined />
                  </span>,
                ],
                icon: [<CopyOutlined />, <CopyOutlined disabled={true} />],
              }}
            >
              {accountTitle}
            </Typography.Title>
          )}
        </Flex>
      }
    >
      <QueryBoundary
        messageHeight={'200px'}
        errorMessage={'Failed to load Account Data.'}
        query={query}
        skeleton={{
          title: false,
          paragraph: { rows: 9, width: '100%' },
        }}
      >
        {children ? (
          children
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty>
        )}
      </QueryBoundary>
    </LinkCard>
  );
};

export default AccountOverview;
